import React, { useState } from "react";
import clsx from "clsx";

import ClassSelectionCheckbox from "../../atoms/ClassSelectionCheckbox";
import { ReactComponent as ArrowDown } from "../../assets/svg/caret_down.svg";
import { IOpenClassList } from "../../state";

import style from "./EveryoneAnswerModalClassDropdown.module.scss";

type IEveryoneAnswerModalClassDropdown = {
  klasses: IOpenClassList[];
  selectedValues: number[];
  setSelectedValues: React.Dispatch<React.SetStateAction<number[]>>;
};

const EveryoneAnswerModalClassDropdown: React.FC<IEveryoneAnswerModalClassDropdown> = ({
  klasses,
  selectedValues,
  setSelectedValues,
}) => {
  const [showClassList, setShowClassList] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    const numericValue = Number(value);
    setSelectedValues(prev =>
      checked ? [...prev, numericValue] : prev.filter(v => v !== numericValue),
    );
  };

  return (
    <div className={style.container}>
      <div
        className={style.titleContainer}
        onClick={() => {
          if (klasses.length > 0) {
            setShowClassList(!showClassList);
          }
        }}
      >
        <div className={style.title}>クラス選択</div>
        <ArrowDown
          onClick={() => {
            if (klasses.length > 0) {
              setShowClassList(!showClassList);
            }
          }}
        />
      </div>
      <div
        className={`${
          showClassList
            ? clsx(style.classContainer, style.showClassContainer)
            : clsx(style.classContainer, style.hideClassContainer)
        }`}
        onClick={e => e.stopPropagation()}
      >
        {klasses.length > 0 &&
          klasses.map(({ name, id, grade }) => (
            <ClassSelectionCheckbox
              key={id}
              name="class"
              value={id}
              label={`${grade}-${name}`}
              checked={selectedValues.includes(id)}
              onChange={handleChange}
            />
          ))}
      </div>
    </div>
  );
};

export default EveryoneAnswerModalClassDropdown;
